import { render } from "./Activate.vue?vue&type=template&id=b5b71374&scoped=true&ts=true"
import script from "./Activate.vue?vue&type=script&lang=ts"
export * from "./Activate.vue?vue&type=script&lang=ts"

import "./Activate.vue?vue&type=style&index=0&id=b5b71374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b71374"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QBtn});
